import { useOutletContext } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import VisibilitySection from 'modules/permissions/components/VisibilitySection'

import { PermissionGroupContainerProps } from '../PermissionGroupContainer'

const VisibilityPage = () => {
  const { permissionGroup } = useOutletContext<PermissionGroupContainerProps>()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <VisibilitySection
      permissionGroup={permissionGroup}
      contractVersions={contractVersions}
      externalLoading={loading}
    />
  )
}

export default observer(VisibilityPage)
